// extracted by mini-css-extract-plugin
export default {"button":"ButtonCore_button__sxpwS"};